<template>

  <section id="add-class">

    <div class="box">

      <div class="field">
        <label class="label">Navn på timen</label>
        <div class="control">
          <input class="input" type="text" placeholder="e.g. Hot yoga" v-model="newWorkout.name">
        </div>
      </div>

      <div class="field has-addons">
        <div class="control is-expanded">
          <label class="label">Studio</label>
          <div class="select is-fullwidth">
            <select name="newWorkout.studio" v-model="newWorkout.studio.name">
              <option value="Shankha">Shankha</option>
              <option value="Pilates Trondheim">Pilates Trondheim</option>
              <option value="Yogaens Hus">Yogaens Hus</option>
              <option value="Terra Yoga">Terra Yoga</option>
              <option value="Fitness Point">Fitness Point</option>
              <option value="Heimdal Klatresenter">Heimdal Klatresenter</option>
              <option value="Trondheim Kickboksing">Trondheim Kickboksing</option>
              <option value="Fitnesspoint">Fitnesspoint</option>
            </select>
          </div>
        </div>
      </div>

  <label class="label">Adresse</label>

<div class="columns">

  <div class="column is-one-quarter">

      <div class="field">
        <label class="label">Gatenummer</label>
        <div class="control">
          <input class="input" type="text" placeholder="" v-model="newWorkout.studio.address.number">
        </div>
      </div>

    </div>
    <div class="column">
      <div class="field">
        <label class="label">Gate</label>
        <div class="control">
          <input class="input" type="text" placeholder="" v-model="newWorkout.studio.address.street">
        </div>
      </div>
    </div>
    <div class="column">
      <div class="field">
        <label class="label">By</label>
        <div class="control">
          <input class="input" type="text" placeholder="" v-model="newWorkout.studio.address.city">
        </div>
      </div>
    </div>
</div>

      <div class="field">
        <label class="label">Tidspunkt</label>
        <div class="control">
          <input class="input" type="text" placeholder="" v-model="newWorkout.time">
        </div>
      </div>

      <div class="field">
        <label class="label">Varighet (minutter)</label>
        <div class="control">
          <input class="input" type="text" placeholder="e.g. 30" v-model="newWorkout.duration">
        </div>
      </div>

      <div class="field">
        <label class="label">Dato</label>
        <div class="control">
          <input class="input" type="date" placeholder="e.g. 12.3.2018" v-model="newWorkout.date">
        </div>
      </div>

      <div class="field has-addons">
        <div class="control is-expanded">
          <label class="label">Type trening</label>
          <div class="select is-fullwidth">
            <select name="newWorkout.type" v-model="newWorkout.type">
              <option value="Yoga">Yoga</option>
              <option value="Pilates">Pilates</option>
              <option value="Klatring">Buldring</option>
              <option value="Svømming">Svømming</option>
              <option value="Kampsport">Kampsport</option>
              <option value="Styke og kondisjon">Styrke og kondisjon</option>
            </select>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">Beskrivelse</label>
        <div class="control">
          <input class="input" type="text" placeholder="e.g. Dette er en tøff, men ..." v-model="newWorkout.description">
        </div>
      </div>

      <div class="field">
        <label class="label">Man trenger</label>
        <label class="checkbox">
          <input type="checkbox" v-model="newWorkout.need.mat">
          Matte
        </label>
        <label class="checkbox">
          <input type="checkbox" v-model="newWorkout.need.towel">
          Håndkle
        </label>
        <label class="checkbox">
          <input type="checkbox" v-model="newWorkout.facilities.towel">
          Drikkeflaske
        </label>
      </div>

      <div class="field">
        <label class="label">Senteret har</label>
        <label class="checkbox">
          <input type="checkbox" v-model="newWorkout.facilities.shower">
          Dusj
        </label>
        <label class="checkbox">
          <input type="checkbox" v-model="newWorkout.facilities.changingRoom">
          Garderobe
        </label>
      </div>


      <div class="field">
        <label class="label">Ledige plasser</label>
        <div class="control">
          <input class="input" type="number" placeholder="e.g. 10" v-model="newWorkout.places_left">
        </div>
      </div>

      <!--<div class="field">
      <label class="label">Type</label>
      <div class="control">
      <input class="input" type="text" placeholder="e.g. Yoga" v-model="newWorkout.type">
    </div>
  </div>-->





  <a class="button" v-on:click="addNewWorkout">Legg til ny time</a>

</div>



<div class="container taster-cities">
  <div class="tabs is-centered">
    <ul>
      <li v-on:click="setActive('Alle')" v-bind:class="{ 'is-active': isActive('Alle')}"><a>Alle</a></li>
      <li v-on:click="setActive('Yoga')" v-bind:class="{ 'is-active': isActive('Yoga')}"><a>Yoga</a></li>
      <li v-on:click="setActive('Styrke')" v-bind:class="{ 'is-active': isActive('Styrke')}"><a>Styrke</a></li>
      <li v-on:click="setActive('Swim')" v-bind:class="{ 'is-active': isActive('Swim')}"><a>Svømming</a></li>
    </ul>
  </div>
</div>


<div class="container taster-dates">
  <div class="tabs is-centered">
    <ul>
      <li class ="has-text-centered" v-on:click="setActiveDay('Mandag')" v-bind:class="{ 'is-active': isActiveDay('Mandag')}"><a>{{ dateNumber }}<br>{{ day }}</a></li>
      <li class ="has-text-centered" v-on:click="setActiveDay('Tirsdag')" v-bind:class="{ 'is-active': isActiveDay('Tirsdag')}"><a>{{ dateNumberTomorrow }}<br>{{ dayTomorrow }}</a></li>
      <li class ="has-text-centered" v-on:click="setActiveDay('Onsdag')" v-bind:class="{ 'is-active': isActiveDay('Onsdag')}"><a>{{ dateNumberThirdday }}<br>{{ dayThirdday }}</a></li>
      <li class ="has-text-centered" v-on:click="setActiveDay('Torsdag')" v-bind:class="{ 'is-active': isActiveDay('Torsdag')}"><a>{{ dateNumberFourthday }}<br>{{ dayFourthday }}</a></li>
      <li class ="has-text-centered" v-on:click="setActiveDay('Fredag')" v-bind:class="{ 'is-active': isActiveDay('Fredag')}"><a>{{ dateNumberFifthday }}<br>{{ dayFifthday }}</a></li>
      <li class ="has-text-centered" v-on:click="setActiveDay('Lørdag')" v-bind:class="{ 'is-active': isActiveDay('Lørdag')}"><a>{{ dateNumberSixthday }}<br>{{ daySixthday }}</a></li>
    </ul>
  </div>
</div>


<!--DAYS TABS-->
<div class="panel-body" v-if="activeDay === 'Mandag'">
  <table class="table table-striped">
    <thead>
      <tr>
        <th>Mandag</th>
        <th>Dato</th>
        <th>key</th>
        <th>Ledige plasser</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(workout, index) in workouts" v-if="today(workout) && activeDay === 'Mandag' && (activeType === workout.type || activeType === 'Alle')">
        <td>{{workout.time}}</td>
        <td>{{ workout.name }}</td>
        <td>{{ workout.date }}</td>
        <td>{{ index }}</td>
        <td>{{ workout.places_left }}</td>
        <td><a class="button" v-on:click="removePlace(index, workout)">Meld på</a></td>
        <td><a class="button" v-on:click="removeWorkout(index)">Slett time</a></td>
      </tr>
    </tbody>
  </table>
</div>

<div class="panel-body" v-if="activeDay === 'Tirsdag'">
  <table class="table table-striped">
    <thead>
      <tr>
        <th>Tirsdag</th>
        <th>Dato</th>
        <th>key</th>
        <th>Ledige plasser</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(workout, index) in workouts" v-if="tomorrow(workout) && activeDay === 'Tirsdag' && (activeType === workout.type || activeType === 'Alle')">
        <td>{{ workout.name }}</td>
        <td>{{ workout.date }}</td>
        <td>{{ index }}</td>
        <td>{{ workout.places_left }}</td>
        <td><a class="button" v-on:click="removePlace(index, workout)">Meld på</a></td>
        <td><a class="button" v-on:click="removeWorkout(index)">Slett time</a></td>
      </tr>
    </tbody>
  </table>
</div>


<!--END DAYS TABS

<h1>ADD STUDIO</h1>
<div class="field">
<label class="label">Studionavn</label>
<div class="control">
<input class="input" type="text" v-model="newStudio.name">
</div>
</div>

<div class="field">
<label class="label">Adresse</label>
<div class="control">
<input class="input" type="text" v-model="newStudio.address">
</div>
</div>

<div class="field">
<label class="label">Type</label>
<div class="control">
<input class="input" type="text" v-model="newStudio.type">
</div>
</div>

<div class="checkbox">
<label class="label">Dusj</label>
<div class="control">
<input class="input" type="text" v-model="newStudio.facilities.shower">
</div>
</div>
<div class="checkbox">
<label class="label">Matte</label>
<div class="control">
<input class="input" type="text" v-model="newStudio.facilities.shower">
</div>
</div>
<div class="checkbox">
<label class="label">Garderobe</label>
<div class="control">
<input class="input" type="text" v-model="newStudio.facilities.shower">
</div>
</div> -->

<button class="button" @click="addDescription">Set descriptions</button>
</section>
</template>



<script>
import Firebase from 'firebase'


export default {


  data() {
    return {
      newWorkout: {
        name: '',
        time: '',
        duration: '',
        date: '',
        studio: {
          address: {
            street:'',
            number: '',
            city: '',
          },
          name: '',
        },
        description: '',
        places_left: '',
        type: '',
        attendees: '',
        keyW: '',
        facilities: {
          shower: '',
          changingRoom: '',
        },
        need: {
          mat:'',
          water: '',
          towel: '',
        },

      },
      activeType: 'Alle',
      activeDay: 'Mandag',
      activeDate: '',
      dropDownActive: false,


      dateNumber: '',
      dateNumberTomorrow: '',
      dateNumberThirdday: '',
      dateNumberFourthday: '',
      dateNumberFifthday: '',
      dateNumberSixthday: '',
      day: '',
      test: '',
    }
  },

  methods: {
    addDescription: function(){
      //THIS FUNCTION IS USED TO SET descriptions

    /*  var testDescription = 'Dette er en test beskrivelse';

      var query = Firebase.database().ref("workouts/").orderByKey();
      query.once("value")
        .then(function(snapshot) {
          snapshot.forEach(function(childSnapshot) {
            // key will be "ada" the first time and "alan" the second time
            var key = childSnapshot.key;
            // childData will be the actual contents of the child
            var childData = childSnapshot.val().name;
            var childStudio = childSnapshot.val().studio.name;

            if(childData === 'Myk yoga' && childStudio === 'Yogaens Hus') {
              Firebase.database().ref('workouts/'+key+'/description').set('Enkel yoga med fokus på øvelser som styrker kroppen. For å få tilgang til å styrke kjernen vår, er pusten sammen bevegelse av ledd og bindevevsstrukturer vesentlig. Målet er økt mobilitet, større bevegelsesfrihet med sterk kjernemuskulatur. Ingen forhåndskunnskaper nødvendig. Du kan være helt ny på yoga.');
            }
        });
      }); */

    },
    dropdownActivate: function(){
      if (this.dropDownActive === false) {this.dropDownActive = true} else {this.dropDownActive = false};
    },
    isDropdownActive: function() {
      return this.dropDownActive === true;
    },
    addNewWorkout: function(){
      var db = Firebase.database();
      var workoutRef = db.ref('workouts/');
      var newKey = db.ref().child('workouts/').push().key;
      this.newWorkout.keyW = newKey;
      var newwo = {};
      newwo['/workouts/'+newKey] = this.newWorkout;

      return db.ref().update(newwo);

      //   workoutRef.push(this.newWorkout);
      this.newWorkout.name ='';
      this.newWorkout.duration ='';
      this.newWorkout.studio = '';
      this.newWorkout.date ='';
      this.newWorkout.description ='';
      this.newWorkout.places_left = '';
      this.newWorkout.type = '';
      this.newWorkout.attendees = '';

    },
    removeWorkout: function (index) {
      var wo = Firebase.database().ref('workouts/'+index);
      wo.remove();
    },
    removePlace: function(index, workout) {
      var wo = Firebase.database().ref('workouts/'+index);
      if(workout.places_left >= 1) { var new_places = workout.places_left - 1} else {alert("Ingen ledige plasser!")};
      wo.update({places_left: new_places});

    },
    today: function(workout) {
      var date = new Date();
      var dd = date.getDate();
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();
      if (mm < 10) {mm = '0'+mm};
      if (dd < 10) {dd = '0'+dd};
      var todaysDate = yyyy+'-'+mm+'-'+dd;

      if(workout.date === todaysDate) { return true };
    },
    tomorrow: function(workout) {
      var date = new Date();
      var dd = date.getDate()+1;
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();
      if (mm < 10) {mm = '0'+mm};
      if (dd < 10) {dd = '0'+dd};
      var tomorrowsDate = yyyy+'-'+mm+'-'+dd;

      if(workout.date === tomorrowsDate) { return true };
    },


    //Date functions
    todayDate: function() {
      var date = new Date();
      var dd = date.getDate();
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();
      if (mm < 10) {mm = '0'+mm};
      if (dd < 10) {dd = '0'+dd};
      var todaysDate = yyyy+'-'+mm+'-'+dd;
      this.activeDate = todaysDate;

      if(this.activeDate === todaysDate) { return true };
    },

    isActive: function(type) {
      return this.activeType === type
    },
    setActive: function (type) {
      this.activeType = type
    },
    isActiveDay: function (weekday) {
      return this.activeDay === weekday
    },
    setActiveDay: function (day) {
      this.activeDay = day
    }
  },

  created() {
    var db = Firebase.database();
    var workouts = this.$bindAsObject('workouts', db.ref('workouts/'));

    //Todays date and days for whole row
    var date = new Date();
    var dd = date.getDate();
    var thisday = date.getDay();

    if (thisday === 1) { this.day = 'Mandag'; this.dayTomorrow = 'Tirsdag'; this.dayThirdday = 'Onsdag'; this.dayFourthday = 'Torsdag'; this.dayFifthday = 'Fredag'; this.daySixthday = 'Lørdag' }
    else if (thisday === 2) { this.day = 'Tirsdag'; this.dayTomorrow = 'Onsdag'; this.dayThirdday = 'Torsdag'; this.dayFourthday = 'Fredag'; this.dayFifthday = 'Lørdag'; this.daySixthday = 'Søndag' }
    else if (thisday === 3) { this.day = 'Onsdag'; this.dayTomorrow = 'Torsdag'; this.dayThirdday = 'Fredag'; this.dayFourthday = 'Lørdag'; this.dayFifthday = 'Søndag'; this.daySixthday = 'Mandag' }
    else if (thisday === 4) { this.day = 'Torsdag'; this.dayTomorrow = 'Fredag'; this.dayThirdday = 'Lørdag'; this.dayFourthday = 'Søndag'; this.dayFifthday = 'Mandag'; this.daySixthday = 'Tirsdag' }
    else if (thisday === 5) { this.day = 'Fredag'; this.dayTomorrow = 'Lørdag'; this.dayThirdday = 'Søndag'; this.dayFourthday = 'Mandag'; this.dayFifthday = 'Tirsdag'; this.daySixthday = 'Onsdag' }
    else if (thisday === 6) { this.day = 'Lørdag'; this.dayTomorrow = 'Søndag'; this.dayThirdday = 'Mandag'; this.dayFourthday = 'Tirsdag'; this.dayFifthday = 'Onsdag'; this.daySixthday = 'Torsdag' }
    else if (thisday === 0) { this.day = 'Søndag'; this.dayTomorrow = 'Mandag'; this.dayThirdday = 'Tirsdag'; this.dayFourthday = 'Onsdag'; this.dayFifthday = 'Torsdag'; this.daySixthday = 'Fredag' };

    var mm = date.getMonth()+1;

    this.dateNumber = dd+'.'+mm;
    //Tomorrows date showed in table
    var to = new Date();
    to.setDate(to.getDate()+1);
    var tomorrow_dd = to.getDate();
    var tomorrow_mm = to.getMonth()+1;
    var tomorrowsDateNumber = tomorrow_dd+'.'+tomorrow_mm;
    this.dateNumberTomorrow = tomorrowsDateNumber;
    //Third days date showed in table
    var th = new Date();
    th.setDate(th.getDate()+2);
    var th_dd = th.getDate();
    var th_mm = th.getMonth()+1;
    var thDateNumber = th_dd+'.'+th_mm;
    this.dateNumberThirdday = thDateNumber;
    //Fourth days date showed in table
    var fh = new Date();
    fh.setDate(fh.getDate()+3);
    var fh_dd = fh.getDate();
    var fh_mm = fh.getMonth()+1;
    var fhDateNumber = fh_dd+'.'+fh_mm;
    this.dateNumberFourthday = fhDateNumber;
    //Tomorrows date showed in table
    var fi = new Date();
    fi.setDate(fi.getDate()+4);
    var fi_dd = fi.getDate();
    var fi_mm = fi.getMonth()+1;
    var fiDateNumber = fi_dd+'.'+fi_mm;
    this.dateNumberFifthday = fiDateNumber;
    //Tomorrows date showed in table
    var si = new Date();
    si.setDate(si.getDate()+5);
    var si_dd = si.getDate();
    var si_mm = si.getMonth()+1;
    var siDateNumber = si_dd+'.'+si_mm;
    this.dateNumberSixthday = siDateNumber;

  },

}

</script>


<style>

.box {
  max-width: 800px;
  margin: auto;
}

#add-class{
  padding-top: 100px;
}

</style>



// WEBPACK FOOTER //
// src/components/AddClass.vue